import { ReactElement } from 'react'

import { InvoicesList } from '@features/invoices/elements/InvoicesList'
import { InvoicesTableAccessor } from '@features/invoices/elements/InvoicesList/enums/invoicesTableAccessor'
import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'

import { TableIds } from '../../../../../../../../enums/tableIds'
import { useOrganizationViewUrl } from '../../../../../../../../hooks/routing/useOrganizationViewUrl'
import { reactRoute } from '../../../../../../../../utils/routing/reactRoute'
import { useContactDetail } from '../../../../contexts/contactDetailContext'

const clientInvoicesListColumns: InvoicesTableAccessor[] = [
  InvoicesTableAccessor.Status,
  InvoicesTableAccessor.InvoiceNumber,
  InvoicesTableAccessor.Type,
  InvoicesTableAccessor.EInvoiceStatus,
  InvoicesTableAccessor.IssueDate,
  InvoicesTableAccessor.DueDate,
  InvoicesTableAccessor.Description,
  InvoicesTableAccessor.IntegrationStatus,
  InvoicesTableAccessor.NetTotal,
]

const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(InvoiceDocumentType.Invoice)

export const ClientInvoicesList = (): ReactElement => {
  const { contact } = useContactDetail()
  const { url: invoicesNewUrl } = useOrganizationViewUrl(
    reactRoute.organization.invoices.getNewDocumentRoute(invoiceDocumentRouteBase),
  )

  return (
    <InvoicesList
      columns={clientInvoicesListColumns}
      contextFilters={{
        customerId: contact.externalId,
      }}
      // A contact with no Zervant externalId cannot own any Zervant invoices, but passing an
      // undefined customerId to useFetchSalesDocuments silently widens to the org-wide list.
      // Disabling the fetch keeps InvoicesList mounted so it renders its natural empty state.
      isFetchEnabled={!!contact.externalId}
      newDocumentUrl={`${invoicesNewUrl}?contact_id=${contact.id}`}
      persistFiltersInUrl={false}
      showTitle={false}
      tableId={TableIds.ClientExternalInvoicesList}
    />
  )
}
